import { put, call } from 'redux-saga/effects';
import { documentList, documentAdd, documentEdit, documentUpdate, documentDelete, documentFileSave, documentFileDelete, skillDocumentList,documentStatusUpdate, passportFileSave, visaFileSave } from '../services/documentService';

import * as types from '../actions';

export function* skillDocumentListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(skillDocumentList, payload);
    yield put({ type: types.DOCUMENT_SKILL_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DOCUMENT_SKILL_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* documentListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(documentList, payload);
      yield put({ type: types.DOCUMENT_LIST_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.DOCUMENT_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* documentAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(documentAdd, payload);
      yield put({ type: types.DOCUMENT_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.DOCUMENT_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* documentEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(documentEdit, payload);
    yield put({ type: types.DOCUMENT_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DOCUMENT_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* documentUpdateSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(documentUpdate, payload);
      yield put({ type: types.DOCUMENT_UPDATE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.DOCUMENT_UPDATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* documentDeleteSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(documentDelete, payload);
      yield put({ type: types.DOCUMENT_DELETE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.DOCUMENT_DELETE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* documentFileSaveSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(documentFileSave, payload);
      yield put({ type: types.DOCUMENT_FILE_SAVE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.DOCUMENT_FILE_SAVE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* documentFileDeleteSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(documentFileDelete, payload);
      yield put({ type: types.DOCUMENT_FILE_DELETE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.DOCUMENT_FILE_DELETE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}
export function* documentStatusUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(documentStatusUpdate, payload);
    yield put({ type: types.DOCUMENT_STATUS_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DOCUMENT_STATUS_UPDATE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* passportFileSaveSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(passportFileSave, payload);
      yield put({ type: types.PASSPORT_FILE_SAVE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.PASSPORT_FILE_SAVE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


export function* visaFileSaveSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(visaFileSave, payload);
    yield put({ type: types.VISA_FILE_SAVE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.VISA_FILE_SAVE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
}
}
